import { Component, HostListener } from '@angular/core';
import { BookingService } from './booking.service';

@Component({
    selector: 'app-booking-modal',
    templateUrl: './booking-modal.component.html',
    styleUrls: ['./booking-modal.component.scss'],
    standalone: false
})
export class BookingModalComponent {

  constructor(public booking: BookingService) { }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    this.booking.close();
  }
}
